import { authStore } from "./authStore";

export function logout() {

  authStore.clear();

  // Tell Angular WC to logout
  window.dispatchEvent(new Event("react-logout"));
}
